// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyTickets_wrapper__Ob1k9","title":"EmptyTickets_title__FA9lJ","subtitle":"EmptyTickets_subtitle__iEkEQ","button":"EmptyTickets_button__-8Nq-"};